//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Action, Divider, Paper, Rating } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import RateSection from '../Page/components/RateSection'

import translations from './Best.translations'
import Comment from './components/Comment'
import Placeholder from './components/Placeholder'

export default {
  components: {
    Action,
    Comment,
    Divider,
    Paper,
    Placeholder,
    RateSection,
    Rating,
  },
  props: {
    review: {
      type: Object,
      default: () => {},
    },
    totalReviews: {
      type: Number,
      default: 0,
    },
    isPlaceholder: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    globalRate: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    translations: () => translations,
    hasReview() {
      return !isEmpty(this.review)
    },
  },
}
